import axios from 'axios'

const API_URL = "http://supportsoft.in/pizza/api";
const state = { 
   pizzaSizes: [],
   noPizaa: [
    {id: 1, value: '1'},
    {id: 2, value: '2'},
    {id: 3, value: '3'},
    {id: 4, value: '4'},
    {id: 5, value: '5'},
    {id: 6, value: '6'},
   ],

 };
const actions = { 
    getMenuSizes({commit}, payload){
        return new Promise((resolve, reject) => {
            let cat_id = payload.cat_id
            let menu_id = payload.menu_id
            let url = API_URL+ '/get-menu-sizes?cat_id='+cat_id+'&menu_id='+menu_id;
            axios.get(url).then(response => {
            let catData = response.data
                commit('updateMenuSizeList', catData)
                resolve()
            }).catch(err => {
                console.log(err);
                reject();
            }); 
        });
    },
    
};
const mutations = { 
    updateMenuSizeList: (store, payload) => {
        store.pizzaSizes = payload;
    },

};
const getters = { 
    getPizzaSizes: (state) => state.pizzaSizes,
    getNoPizza: (state) => state.noPizaa,
};
export default {
    state,
    actions,
    mutations,
    getters
};